import { Loader } from "@/server/agent";

interface LoadersState {
  loaders: Loader[];
  loading: boolean;
}

const initialState: LoadersState = {
  loaders: [],
  loading: false,
};

interface SetLoadersAction {
  type: "SET_LOADERS";
  payload: Loader[];
}

interface SetLoadersLoadingAction {
  type: "SET_LOADERS_LOADING";
  payload: boolean;
}

type LoadersAction = SetLoadersAction | SetLoadersLoadingAction;

export const loadersReducer = (
  state: LoadersState = initialState,
  action: LoadersAction
): LoadersState => {
  switch (action.type) {
    case "SET_LOADERS": {
      return { ...state, loaders: action.payload };
    }
    case "SET_LOADERS_LOADING": {
      return { ...state, loading: action.payload };
    }
    default:
      return state;
  }
};
